import axiosInstance from './axiosInstance'

export const getOpportunityById = (opportunityId) => {
  return axiosInstance.get(`/opportunities/${opportunityId}`)
}

export const getOpportunities = (page = 1, limit = 50, search = '', orderByKey = 'name', direction = 'asc') => {
  return axiosInstance.get(`/opportunities?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const exportOpportunities = ({ search = '', orderByKey = 'name', direction = 'asc' } = {}) => {
  return axiosInstance.get(`/opportunities/export?search=${search}&orderByKey=${orderByKey}&direction=${direction}`, { responseType: 'blob' })
}

export const createOpportunity = (data) => {
  return axiosInstance.post('/opportunities', data)
}

export const updateOpportunity = (opportunityId, data) => {
  return axiosInstance.put(`/opportunities/${opportunityId}`, data)
}

export const deleteOpportunity = (opportunityId) => {
  return axiosInstance.delete(`/opportunities/${opportunityId}`)
}
